import { recapPath } from './api';
import { defaultParseSearch } from '@tanstack/react-router';

/** Preserve the canonical decimal wire spelling before JSON query parsing can
 * round a BIGINT. Other keys and router-serialized quoted strings stay normal. */
export function parseSearchWithRecapId(search: string): Record<string, unknown> {
  const parsed: Record<string, unknown> = defaultParseSearch(search);
  const values = new URLSearchParams(search).getAll('recap_id');
  if (values.length === 1 && parseRecapId(values[0])) parsed.recap_id = values[0];
  return parsed;
}

/** Canonical recap navigation never rounds BIGINTs or reinterprets legacy
 * numeric `summary` notifications as new canonical roots. */
export function parseRecapId(value: unknown): string | undefined {
  if (typeof value !== 'string') return undefined;
  try { recapPath(value); return value; } catch { return undefined; }
}
export function recapNavigationTarget(recapId: string, view: 'coach' | 'recipient') {
  recapPath(recapId);
  return view === 'coach'
    ? { to: '/coach' as const, search: { tab: 'library' as const, library_kind: 'recaps' as const, recap_id: recapId } }
    : { to: '/feedback' as const, search: { tab: 'feedback' as const, recap_id: recapId } };
}
